import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const getMediaFilePermissionsByUserAndProject = async (
  projectId,
  lastEvaluatedKey
) => {
  const apiPath = `projects/${projectId}/user-media-file-permissions`;

  const body = {
    lastEvaluatedKey: lastEvaluatedKey,
  };

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    region: Config.AWS_REGION,
    service: 'execute-api',
    data: body,
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
